import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const container = document.getElementById("pipelines-container");
    const resultsContainer = document.getElementById("pipelines-results");
    const pipelinesButton = document.getElementById("dropdown-pipelines-button");
    const pipelinesMenu = document.getElementById("dropdown-pipelines-menu");
    let loadingTimeout;
    
    if (container.dataset.path.match(/\/pipelines(\/|$)/) && !container.dataset.path.match(/\/modeling/)) {
      fetchPipelines();
    }

    pipelinesButton.addEventListener("click", fetchPipelines);
    
    async function fetchPipelines() {
      if (resultsContainer.dataset.fetched === "true") {
        return;
      }

      const account_id = resultsContainer.dataset.accountId
      const selected_pipeline_id = resultsContainer.dataset.pipelineId

      try {
        const response = await fetch(`/admin/accounts/${account_id}/pipelines/menu_items`, {
          headers: { Accept: "application/json" }
        })
        const results = await response.json();

        clearTimeout(loadingTimeout);
        
        resultsContainer.innerHTML = results.map(result => {
          let selected = String(result[0]) === selected_pipeline_id

          return `
            <div>
              <a href="/admin/accounts/${account_id}/pipelines/${result[0]}" style="font-family:Space Grotesk" class="text-sm truncate overflow-hidden block w-full px-2 py-1 hover:text-gray-200 cursor-pointer rounded-lg ${selected ? "text-gray-100 bg-gray-900 pl-2" : "text-gray-400"}">
                • ${result[1]}
              </a>
            </div>
          `;
        }).join("");

        resultsContainer.dataset.fetched = "true";
        pipelinesMenu.style.maxHeight = pipelinesMenu.scrollHeight + "px";
      } catch (error) {
        clearTimeout(loadingTimeout);
        console.error("Platfrom connections fetch error:", error);
      }
    }
  }
}